// gatsby-browser.js

export const onRouteUpdate = ({ location }) => {
  // 1. Capture UTM + Google click IDs from URL and store in session.
  //    utmParams holds the combined attribution query string (UTMs plus any
  //    gclid/gbraid/wbraid present), used to decorate the CRM Source Page URL.
  const CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'];
  const searchParams = new URLSearchParams(location.search);
  const utmParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith('utm_') || CLICK_ID_KEYS.includes(key)) {
      utmParams.push(`${key}=${value}`);
    }
  }

  // Store the combined attribution string in sessionStorage if available
  if (utmParams.length > 0) {
    sessionStorage.setItem('utmParams', utmParams.join('&'));
  }

  // 1b. Persist individual attribution keys for the lead forms (single source
  // of truth). This includes Google Ads click IDs (gclid/gbraid/wbraid).
  // Only write when the param is present in the URL, so navigating to a page
  // without attribution never overwrites a previously stored value.
  const ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
  ];
  try {
    ATTRIBUTION_KEYS.forEach(key => {
      const value = searchParams.get(key);
      if (value) {
        sessionStorage.setItem(key, value);
      }
    });
  } catch (e) {
    // sessionStorage can throw (private mode / blocked storage); ignore.
  }

  // 2. Forward stored attribution (UTMs + Google click IDs) to outbound Sensei
  //    links: the 3D viewer (sensei3d) and Sensei Sheds
  //    (bambuildingsheds.senseisheds.com). Uses URL/URLSearchParams so params
  //    are never duplicated when a link is processed more than once, and only
  //    adds a param that the link does not already carry.
  const SENSEI_LINK_SELECTOR = 'a[href*="sensei3d"]';

  const updateSenseiLinks = () => {
    let stored;
    try {
      stored = ATTRIBUTION_KEYS
        .map(key => [key, sessionStorage.getItem(key)])
        .filter(([, value]) => value);
    } catch (e) {
      return; // sessionStorage unavailable
    }
    if (stored.length === 0) return;

    document.querySelectorAll(SENSEI_LINK_SELECTOR).forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      let url;
      try {
        // Resolve against the current origin so relative/absolute both parse.
        url = new URL(href, window.location.origin);
      } catch (e) {
        return; // skip malformed hrefs
      }
      let changed = false;
      stored.forEach(([key, value]) => {
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, value);
          changed = true;
        }
      });
      if (changed) {
        // Preserve the original form (absolute vs protocol-relative) by only
        // writing back the string URL produced by URL serialization.
        link.setAttribute('href', url.toString());
      }
    });
  };

  // Run update on page load and route change
  if (document.readyState === 'complete') {
    updateSenseiLinks();
  } else {
    window.addEventListener('load', updateSenseiLinks);
  }
};
